<template>
   <div class="sign-in-form">
      <p class="text-center">
         Sign into your account
      </p>
      <form @submit.prevent="on_submit">
         <div class="input-group mb-3">
            <div class="input-group-prepend">
               <span class="input-group-text">
                  <i class="fas fa-user"></i>
               </span>
            </div>
            <input type="text" class="form-control" placeholder="Username" 
               aria-label="Username" title="Please enter your username." autofocus="autofocus"
               v-model="username"/>
         </div>

         <div class="input-group mb-3">
            <div class="input-group-prepend">
               <span class="input-group-text">
                  <i class="fas fa-lock"></i>
               </span>
            </div>
            <input type="password" class="form-control" placeholder="Password" 
               aria-label="Password" title="Please enter your password."
               v-model="password"/>
         </div>

         <button class="sign-in-form__btn btn btn-primary">
            <i class="fas fa-unlock"></i>
            Sign in
         </button>
      </form>
   </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

export default {
   data(){
      return {
         id: Math.floor( Math.random() * 10000000 ),
      }
   },

   computed:{
      username: {
         get (){
            return this.$store.state.username
         },
         set ( value ){
            this.$store.state.username = value;
         }
      },
      password: {
         get (){
            return this.$store.state.password
         },
         set ( value ){
            this.$store.state.password = value;
         }
      },

      ...mapGetters([
         'show_dashboard',
         'message_too_many_logins'
      ])
   }, // /computed()

   methods:{
      on_submit(){
         this.show_wait( `Verifying your login...`, 50 );
         this.login_session({
            username: this.username,
            password: this.password
         })
         .then((o_result) => {
            this.clear_show();

            if( !o_result.user.hasOwnProperty( 'session_id' ) ){
               // This user has too many previous login failures within 24 hours.
               return this.show_error( this.message_too_many_logins );
            }


            this.show_wait( `Almost there...`, 75 );
            document.cookie = `sid=${o_result.user.session_id}; path=/ ; max-age=31536000`;

            // Wait a second for the loading animation to update.
            setTimeout(()=>{
               const a_href = window.location.href.split( '/' );
               const o_user = o_result.user;
               // pathname: "/5000/"
               // href: "http://localhost:8080/5000/#/"

               if( this.show_dashboard ) {
                  return location.assign( `/${o_user.client_id}/dashboard.wr` );
               }
               
               if( /^\d+$/.test( a_href[3] ) && a_href[3] != `${o_user.client_id}` ){
                  /** 
                   * This user is viewing a url with a client id that changed
                   * after they logged in again. Most likely their session time
                   * out and they just logged back in on the same page. Alter 
                   * the url to show the current client id.
                   */
                  a_href[3] = o_user.client_id;
                  return window.location.assign( a_href.join( '/' ) );
               }
               
               window.location.reload( true );
            }, 1000 );
         })
         .catch((o_error) => {
            this.show_error( o_error.message );
         });
      },

      ...mapActions([
         'login_session'
      ])
   }
}
</script>

<style scoped>
.sign-in-form
{
   border: 0;
}

.sign-in-form__btn
{
   width: 100%;
}
</style>
